import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import { TitleProvider } from './components/TitleContext'; // Import the provider
import Navbar from './components/Navbar';
// Import other components for your pages
import Header from './components/Header';
import HomePage from './components/HomePage'; // Import HomePage
import PoliticalBias from './components/PoliticalBias'; // Adjust the import path as necessary
import './App.css';
import PositivitySentiment from './components/PositivitySentiment';
import MediaMentions from './components/MediaMentions';


function App() {
  return (
    <TitleProvider>
      <Router>
      <div className="search-container">
        <div className="date-range-container">
          <label htmlFor="start-date" className="date-label">Date Range</label>
          <div className="date-inputs">
            <input type="date" id="start-date" className="date-input" />
            <span className="to-spacing">to</span>
            <input type="date" id="end-date" className="date-input" />
          </div>
        </div>
        <div className="keyword-search-container">
          <label htmlFor="keyword-search" className="search-label">Keyword Search</label>
          <input type="text" id="keyword-search" className="search-box" placeholder="Enter keywords" />
        </div>
      </div>
      <Navbar />
      <Header /> 
      <hr className="divider" />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/political_bias" element={<PoliticalBias />} />
        <Route path="/positivity_sentiment" element={<PositivitySentiment />} />
        <Route path="/media_mentions" element={<MediaMentions />} />
      </Routes>
    </Router>
  </TitleProvider>
  );
}

export default App;
